import React, { useEffect, useState } from 'react'
import { capitalizeAndRemoveUnderscores, downloadFile, limitWords } from '../../../utils/utils';
import { formatIndianDate } from '../../../utils/Constant';
import { Spin, Table, Tooltip, Space } from 'antd';
import Pnation from '../../../components/Pagination/pagination';
import CustomSearch from '../../../components/search/CustomSearch';
import { DownloadOutlined } from "@ant-design/icons";
import HoverIcon from '../../../components/icons/HoverIcon';

export default function AllUploaded() {
  const [arcData, setArcData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '' });
  const [isLoading, setIsloading] = useState(false);
  const [downloadingId, setDownloadingId] = useState('')

  const onDownload = async (record) => {
    try {
      setDownloadingId(record.document_id)
      await downloadFile(record.agreement_file)
    } catch (error) {
    } finally {
      setDownloadingId('')
    }
  }

  const columns = [
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Date of Raising (dd-mm-yyyy)">Date of Raising <br />
          (dd-mm-yyyy)</Tooltip>
      ),
      dataIndex: "date_of_execution",
      key: "date_of_execution",
      width: 140,
      ellipsis: true,
      render: (date, record) => (
        <span style={{ fontWeight: "normal" }}>
          {formatIndianDate(date)}
        </span>
      ),
    },
    {
      title: "Agreement Type",
      dataIndex: "agreement_type",
      width: 160,
      ellipsis: true,
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontWeight: "normal",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Partner Name",
      dataIndex: "name_of_client",
      width: 140,
      ellipsis: true,
      render: (text, record) => (
        <span style={{ fontWeight: "normal" }}>
          {text && text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: "Nature",
      dataIndex: "nature",
      width: 100,
      ellipsis: true,
      render: (text, record) => (
        <span style={{ fontWeight: "normal" }}>
          {text && text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      ellipsis: true,
      render: (text, record) => (
        <span style={{ fontWeight: "normal" }}>
          {capitalizeAndRemoveUnderscores(text)}
        </span>
      ),
    },
    // {
    //   title: <Tooltip className="whitespace-nowrap" title="Remarks(if any)">
    //     <span>Remarks(if any)</span>
    //   </Tooltip>,
    //   dataIndex: "remarks",
    //   width: 140,
    //   ellipsis: true, // Enable ellipsis for the column
    //   render: (text, record) => (
    //     <Tooltip title={text}>
    //       <div
    //         style={{
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           whiteSpace: "nowrap",
    //           fontWeight: "normal",
    //         }}
    //       >
    //         {limitWords(text, 6)}
    //       </div>
    //     </Tooltip>
    //   ),
    // },
    {
      title: "Download File",
      key: "upload",
      width: 140,
      ellipsis: true,
      render: (_, record, index) => (
        <Space>
          <HoverIcon
            icon={<DownloadOutlined />}
            tooltip="Download This Agreement"
            color={"rgb(163, 149, 218)"} // Blue for unarchive, yellow for archive
            hoverColor="white"
            hoverBgColor={"rgb(163, 149, 218)"} // Dynamic hover effect
            disabled={downloadingId == record.document_id}
            onClick={() => onDownload(record)}
            isLoading={downloadingId == record.document_id}
          />
        </Space>
      ),
    }
  ];
  const onPeding = (val) => {
    setIsloading(val)
  }

  const getData = (data) => {
    setArcData(data)
  }
  const handleSearch = (value) => {
    setSearchKeyword((val) => {
      val.search_keyword = value;
      return { ...val }
    })
  };


  return (
    <div>
      <div className="flex flex-row  pb-3 px-2 justify-between my-2 align-middle">
        <span>
          <h1
            className="mt-1 text-lg font-[700] text-[30px] "
          >
            Bulk Uploaded List
          </h1>
        </span>
        <div className="pl-4">
          <CustomSearch onSearch={handleSearch} />
        </div>
      </div>
      {/* <div className="pl-4">
      <CustomSearch onSearch={handleSearch} />
    </div> */}
      <div className=" border border-gray-300">
        <Spin spinning={isLoading} tip="Loading...">
          <Table
            columns={columns}
            dataSource={arcData}
            scroll={{ x: "max-content", y: 400 }}
            pagination={false}
            className='text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]'
          />
        </Spin>
      </div>
      <Pnation onPeding={onPeding} onCngPage={getData} url='/contract/bulk-agreements-list/' plod={searchKeyword} itmeName={`Bulk Uploaded Contracts`} />
    </div>
  )
}
